import type { Conversation } from '../types';
import { getChatParticipants } from './chat-utils';

/**
 * The width of the chat inbox drawer.
 */
export const DRAWER_WIDTH_REM = 24;
/**
 * The margin of the chat inbox drawer.
 */
export const DRAWER_MARGIN_REM = 1;
/**
 * The width of the chat box when it is open.
 */
export const CHAT_BOX_OPEN_WIDTH_PX = 480;
/**
 * The minimum width of the chat box when it is minimised. Group chat chat boxes
 * have a larger minimised width than 1-on-1 chat boxes.
 */
export const CHAT_BOX_CLOSED_WIDTH_REM = 3.5;
/**
 * The spacing between chat boxes.
 */
export const SPACING_PX = 12;

/**
 * Calculate the width of a minimised chat box in rem. The width needs to be
 * calculated to:
 * - Animate the chat box width transition.
 * - Calculate the available space for new chat boxes.
 * @param conversation The conversation to calculate the minimised width for.
 */
export function getChatBoxMinimisedWidthRem(
    conversation: Conversation | undefined
) {
    const participantCount =
        conversation?.__typename === 'DirectConversation' &&
        conversation.IsGroupChat
            ? getChatParticipants(conversation).length
            : 1;
    if (participantCount <= 1) {
        return CHAT_BOX_CLOSED_WIDTH_REM;
    }
    return (
        CHAT_BOX_CLOSED_WIDTH_REM +
        // Overlapping avatars.
        Math.min(participantCount - 1, 3) * 1.25 +
        // Padding.
        0.25
    );
}
